/* shop-the-rack.js — bundled from rack-prototype (physics + lightbox + rack).
 * Products + cart config are injected by the section as window.SHOP_THE_RACK.
 * DO NOT EDIT HERE — edit rack-prototype/src and re-run bundle-theme.mjs. */


/* ===== src/physics.js ===== */
/*
 * physics.js — tiny spring engine for the rack.
 *
 * Two uses:
 *   1. The rack "scroll" position springs to the focused item on release (snap).
 *   2. Each garment's hanger sway is a damped pendulum returning to rest (0deg).
 *
 * Classic mass-spring-damper integrated with semi-implicit (symplectic) Euler,
 * which stays stable at the small fixed timestep the main loop feeds it.
 *
 * Exposed as window.RackPhysics so it works from a plain <script> (no bundler,
 * opens straight off the filesystem — no dev server required).
 */
(function () {
  'use strict';

  function Spring(opts) {
    opts = opts || {};
    this.value = opts.value || 0; // current position
    this.velocity = 0; // current velocity (units / second)
    this.target = opts.target || 0; // rest position the spring pulls toward
    this.stiffness = opts.stiffness == null ? 120 : opts.stiffness; // k
    this.damping = opts.damping == null ? 14 : opts.damping; // c
    this.mass = opts.mass == null ? 1 : opts.mass; // m
  }

  // Move the rest position (garment stops swinging toward this angle).
  Spring.prototype.setTarget = function (t) {
    this.target = t;
    return this;
  };

  // Kick the spring — e.g. a flick imparts momentum, a bump adds a jolt.
  Spring.prototype.impulse = function (dv) {
    this.velocity += dv;
    return this;
  };

  // Jump the value without any velocity (used while the user is dragging).
  Spring.prototype.setValue = function (v) {
    this.value = v;
    return this;
  };

  // Advance one fixed step. dt in seconds. Returns the new value.
  Spring.prototype.step = function (dt) {
    var force = -this.stiffness * (this.value - this.target) - this.damping * this.velocity;
    var accel = force / this.mass;
    this.velocity += accel * dt;
    this.value += this.velocity * dt;
    return this.value;
  };

  // True once the spring has effectively come to rest at its target.
  Spring.prototype.atRest = function (epsPos, epsVel) {
    epsPos = epsPos == null ? 0.001 : epsPos;
    epsVel = epsVel == null ? 0.001 : epsVel;
    return Math.abs(this.value - this.target) < epsPos && Math.abs(this.velocity) < epsVel;
  };

  function clamp(v, lo, hi) {
    return v < lo ? lo : v > hi ? hi : v;
  }

  window.RackPhysics = { Spring: Spring, clamp: clamp };
})();


/* ===== src/lightbox.js ===== */
/*
 * lightbox.js — product card shown when you tap the focused garment.
 *
 * Renders the real M&P photo, the product's option groups (Size — and any
 * others, generically), a quantity stepper and Add to Cart. Variant is resolved
 * by matching the selected option values against each variant's options[].
 *
 * Add to Cart routes through the shared window.RackBag (mock bag in the
 * prototype, real Shopify /cart/add.js in the theme).
 *
 * Exposed as window.RackLightbox.open(product).
 */
(function () {
  'use strict';

  var root, backdrop, card, imgEl, titleEl, priceEl, descEl, optsEl, qtyValEl, addBtn, noteEl, linkEl, toastEl;
  var current = null; // { product, selected: [values], qty }
  var lastFocused = null;

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function build() {
    root = document.getElementById('lightbox');
    root.setAttribute('hidden', '');
    backdrop = el('div', 'lb-backdrop');
    card = el('div', 'lb-card');
    card.setAttribute('role', 'dialog'); card.setAttribute('aria-modal', 'true');

    var close = el('button', 'lb-close', '&times;'); close.setAttribute('aria-label', 'Close');
    var media = el('div', 'lb-media'); imgEl = el('img', 'lb-img'); imgEl.alt = ''; media.appendChild(imgEl);

    var info = el('div', 'lb-info');
    info.appendChild(el('p', 'lb-vendor', 'Mamas &amp; Papas'));
    titleEl = el('h2', 'lb-title'); priceEl = el('p', 'lb-price'); descEl = el('p', 'lb-desc');
    optsEl = el('div', 'lb-opts');
    info.appendChild(titleEl); info.appendChild(priceEl); info.appendChild(descEl); info.appendChild(optsEl);

    var qtyRow = el('div', 'lb-qty');
    var minus = el('button', 'lb-step', '&minus;'), plus = el('button', 'lb-step', '+');
    qtyValEl = el('span', 'lb-qtyval', '1');
    minus.addEventListener('click', function () { setQty(current.qty - 1); });
    plus.addEventListener('click', function () { setQty(current.qty + 1); });
    qtyRow.appendChild(el('span', 'lb-oplabel', 'Qty')); qtyRow.appendChild(minus); qtyRow.appendChild(qtyValEl); qtyRow.appendChild(plus);

    addBtn = el('button', 'lb-add', 'Add to cart'); addBtn.addEventListener('click', addToCart);
    noteEl = el('p', 'lb-note');
    linkEl = el('a', 'lb-link', 'View full details');
    info.appendChild(qtyRow); info.appendChild(addBtn); info.appendChild(noteEl); info.appendChild(linkEl);

    card.appendChild(close); card.appendChild(media); card.appendChild(info);
    root.appendChild(backdrop); root.appendChild(card);

    close.addEventListener('click', hide);
    backdrop.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hasAttribute('hidden')) hide(); });
    toastEl = document.getElementById('toast');
  }

  function arrEq(a, b) { return a.length === b.length && a.every(function (v, k) { return v === b[k]; }); }
  function variantFor(sel) { return current.product.variants.filter(function (v) { return arrEq(v.options, sel); })[0]; }

  function renderOptions() {
    var p = current.product;
    optsEl.innerHTML = '';
    p.options.forEach(function (opt, oi) {
      var grp = el('div', 'lb-opt');
      grp.appendChild(el('span', 'lb-oplabel', opt.name));
      var choices = el('div', 'lb-choices');
      opt.values.forEach(function (val) {
        var b = el('button', 'lb-chip', val);
        // does any variant with this value (for this option) exist & is available?
        var anyAvail = p.variants.some(function (v) { return v.options[oi] === val && v.available; });
        if (!anyAvail) b.classList.add('is-oos');
        if (current.selected[oi] === val) b.classList.add('is-active');
        b.addEventListener('click', function () { current.selected[oi] = val; sync(); });
        choices.appendChild(b);
      });
      grp.appendChild(choices);
      optsEl.appendChild(grp);
    });
  }

  function setQty(n) { current.qty = Math.max(1, Math.min(10, n)); qtyValEl.textContent = current.qty; }

  function sync() {
    var p = current.product, v = variantFor(current.selected);
    imgEl.src = p.image;
    titleEl.textContent = p.title;
    priceEl.textContent = window.formatPrice((v || p).priceCents, p.currency);
    descEl.textContent = p.description;
    if (p.url) { linkEl.href = p.url; linkEl.hidden = false; } else { linkEl.hidden = true; }
    renderOptions();
    if (v && v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; noteEl.textContent = ''; }
    else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; noteEl.textContent = 'This size is currently unavailable.'; }
  }

  function addToCart() {
    var v = variantFor(current.selected); if (!v || !v.available) return;
    // one shared cart path (window.RackBag) handles both the mock bag and the
    // real Shopify cart — see rack.js. Close the card so the cart is visible.
    if (window.RackBag) {
      window.RackBag.add({ product: current.product, variant: v, qty: current.qty,
        label: current.selected.join(' / '), fromEl: imgEl });
      hide();
    }
  }

  function firstAvailableSelection(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    return v ? v.options.slice() : p.options.map(function (o) { return o.values[0]; });
  }

  function open(product) {
    if (!root) build();
    current = { product: product, selected: firstAvailableSelection(product), qty: 1 };
    setQty(1); sync();
    lastFocused = document.activeElement;
    root.removeAttribute('hidden');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
  }
  function hide() {
    root.classList.remove('is-open');
    setTimeout(function () { root.setAttribute('hidden', ''); if (lastFocused && lastFocused.focus) lastFocused.focus(); }, 260);
  }

  window.RackLightbox = { open: open };
})();


/* ===== src/tryon.js ===== */
/*
 * tryon.js — the virtual fitting room.
 *
 * A child "model" avatar docks in the corner of the rack. Drag a garment onto
 * it (or tap it) and it opens the fitting-room panel and calls the try-on
 * SERVICE (which holds the Fal key and runs FASHN) — showing the child wearing
 * the garment. Age tabs (Newborn / Baby / Toddler) re-render on the fly.
 *
 * Enabled only when the page provides window.SHOP_THE_RACK.tryon = { url }.
 * Exposed as window.RackTryOn (rack.js calls isOver / hover / tryOn on drag).
 */
(function () {
  'use strict';

  var CFG = null;
  var AGES = [{ id: 'newborn', label: 'Newborn' }, { id: 'baby', label: 'Baby' }, { id: 'toddler', label: 'Toddler' }];
  var currentAge = 'baby', currentProduct = null, reqSeq = 0;
  var stageEl, dock, avatarImg, panel, panelImg, panelTitle, panelLoading, panelNote, tabsEl;
  var rateRow, rateUp, rateDown, currentKey = null;

  // playful "baking the look" loader — a climbing % + rotating kid-friendly quips
  var bakeEmoji, bakePctEl, bakeFill, bakeQuip, bakePct = 0, bakeTimer = null, quipTimer = null, quipIdx = 0;
  var QUIPS = [
    { t: 'Warming up the fitting room…', e: '🪄' },
    { t: 'Picking the perfect size…', e: '📏' },
    { t: 'Tying the little bow…', e: '🎀' },
    { t: 'Smoothing out the wrinkles…', e: '🧺' },
    { t: 'Adding a sprinkle of cute…', e: '✨' },
    { t: 'Getting ready for the catwalk…', e: '🐣' },
    { t: 'Almost picture-perfect…', e: '🧸' }
  ];
  function setBake() { var p = Math.round(bakePct); if (bakePctEl) bakePctEl.textContent = p + '%'; if (bakeFill) bakeFill.style.width = p + '%'; }
  function showQuip(i) { if (bakeQuip) bakeQuip.textContent = QUIPS[i].t; if (bakeEmoji) { bakeEmoji.textContent = QUIPS[i].e; bakeEmoji.classList.remove('pop'); void bakeEmoji.offsetWidth; bakeEmoji.classList.add('pop'); } }
  function startBake() {
    stopBake(); bakePct = 0; quipIdx = 0; setBake(); showQuip(0);
    bakeTimer = setInterval(function () { bakePct += Math.max(0.4, (95 - bakePct) * 0.045); if (bakePct > 95) bakePct = 95; setBake(); }, 350);
    quipTimer = setInterval(function () { quipIdx = (quipIdx + 1) % QUIPS.length; showQuip(quipIdx); }, 2200);
  }
  function finishBake() { bakePct = 100; setBake(); stopBake(); }
  function stopBake() { if (bakeTimer) clearInterval(bakeTimer); if (quipTimer) clearInterval(quipTimer); bakeTimer = quipTimer = null; }

  // FASHN maps ONE garment at a time, so single one-piece styles work great;
  // multi-piece Outfit Sets / Dungarees / open cardigans do not. Only try those.
  var TRYABLE = { Romper: 1, Rompers: 1, Sleepsuit: 1, Sleepsuits: 1, Dress: 1, Bodysuit: 1, Bodysuits: 1, Swimsuit: 1 };
  function tryable(p) { return !!(p && TRYABLE[p.type]); }

  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function modelSrc(age) { return (CFG.modelsBase || 'assets/models/') + age + '.png'; }

  function init(cfg) {
    CFG = cfg || {};
    if (cfg.ages) AGES = cfg.ages;
    stageEl = document.getElementById('stage');
    buildDock();
    buildPanel();
  }

  function buildDock() {
    dock = el('div', 'fitroom-dock');
    var face = el('div', 'fitroom-face');
    avatarImg = el('img', 'fitroom-avatar'); avatarImg.src = CFG.faceSrc || (CFG.modelsBase || 'assets/models/') + 'teaser-face.png';
    avatarImg.alt = 'Try it on'; avatarImg.draggable = false;
    face.appendChild(avatarImg);
    face.appendChild(el('span', 'fitroom-face-ring'));
    dock.appendChild(face);
    dock.appendChild(el('div', 'fitroom-dock-title', 'Try&nbsp;it&nbsp;on <span class="fitroom-spark">✨</span>'));
    dock.appendChild(el('div', 'fitroom-dock-hint', 'Drag a piece onto me'));
    dock.addEventListener('click', function () { openPanel(currentProduct); });
    stageEl.appendChild(dock);
  }

  function buildPanel() {
    panel = el('div', 'fitroom'); panel.hidden = true;
    var backdrop = el('div', 'fitroom-backdrop');
    var card = el('div', 'fitroom-card');
    var close = el('button', 'fitroom-close', '&times;'); close.addEventListener('click', closePanel);

    var media = el('div', 'fitroom-media');
    panelImg = el('img', 'fitroom-img'); panelImg.alt = '';
    panelLoading = el('div', 'fitroom-loading');
    var bake = el('div', 'fitroom-bake');
    var bstage = el('div', 'fitroom-bake-stage');
    bakeEmoji = el('span', 'fitroom-bake-emoji', QUIPS[0].e); bstage.appendChild(bakeEmoji);
    bakePctEl = el('div', 'fitroom-bake-pct', '0%');
    var bbar = el('div', 'fitroom-bake-bar'); bakeFill = el('span', 'fitroom-bake-fill'); bbar.appendChild(bakeFill);
    bakeQuip = el('div', 'fitroom-bake-quip', QUIPS[0].t);
    bake.appendChild(bstage); bake.appendChild(bakePctEl); bake.appendChild(bbar); bake.appendChild(bakeQuip);
    panelLoading.appendChild(bake);
    media.appendChild(panelImg); media.appendChild(panelLoading);

    var info = el('div', 'fitroom-info');
    info.appendChild(el('p', 'fitroom-kicker', 'Virtual fitting room'));
    panelTitle = el('h3', 'fitroom-title', ''); info.appendChild(panelTitle);
    info.appendChild(el('span', 'fitroom-oplabel', 'Age'));
    tabsEl = el('div', 'fitroom-tabs');
    AGES.forEach(function (a) {
      var b = el('button', 'fitroom-tab' + (a.id === currentAge ? ' is-active' : ''), a.label);
      b.addEventListener('click', function () {
        currentAge = a.id; // dock keeps the teaser face; age only drives the try-on
        tabsEl.querySelectorAll('.fitroom-tab').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        if (currentProduct) run(currentProduct);
      });
      tabsEl.appendChild(b);
    });
    info.appendChild(tabsEl);
    var add = el('button', 'fitroom-add', 'Add to cart');
    add.addEventListener('click', function () { if (currentProduct) { closePanel(); if (window.RackLightbox) window.RackLightbox.open(currentProduct); } });
    info.appendChild(add);

    // rating row — 👍 keeps this cached look, 👎 re-rolls a fresh one
    rateRow = el('div', 'fitroom-rate'); rateRow.style.visibility = 'hidden';
    rateRow.appendChild(el('span', 'fitroom-rate-label', "How's this look?"));
    rateUp = el('button', 'fitroom-rate-btn', '👍'); rateUp.title = 'Looks good — keep it';
    rateDown = el('button', 'fitroom-rate-btn', '👎'); rateDown.title = "Not right — try again";
    rateUp.addEventListener('click', function () { sendRate('up'); });
    rateDown.addEventListener('click', function () { sendRate('down'); });
    rateRow.appendChild(rateUp); rateRow.appendChild(rateDown);
    info.appendChild(rateRow);

    panelNote = el('p', 'fitroom-note', 'AI preview — actual fit and colour may vary.');
    info.appendChild(panelNote);

    card.appendChild(close); card.appendChild(media); card.appendChild(info);
    panel.appendChild(backdrop); panel.appendChild(card);
    backdrop.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closePanel(); });
    // NOT inside #stage: the stage sets `perspective`, which makes it the containing
    // block for position:fixed — the panel would be trapped in the stage and clipped
    // by its overflow:hidden (head cut off, Add to cart unreachable on mobile).
    // Mount on the section root so it's a true viewport-level modal (scoped CSS still applies).
    (stageEl.closest('.shop-the-rack') || document.body).appendChild(panel);
  }

  // ---- drag target API (used by rack.js) ------------------------------------
  function isOver(x, y) { var r = dock.getBoundingClientRect(); return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom; }
  function hover(x, y) { dock.classList.toggle('is-drop', isOver(x, y)); }
  function clearHover() { dock.classList.remove('is-drop'); }

  // ---- panel + try-on -------------------------------------------------------
  function showBase(title, note) {
    dock.classList.remove('is-busy');
    stopBake();
    panelLoading.classList.remove('is-show');
    panelImg.classList.remove('is-ready');
    panelImg.onload = function () { panelImg.classList.add('is-ready'); };
    panelImg.src = modelSrc(currentAge);
    panelTitle.textContent = title;
    panelNote.textContent = note || 'AI preview — actual fit and colour may vary.';
    if (rateRow) rateRow.style.visibility = 'hidden';
  }
  function setRating(r) {
    if (rateUp) rateUp.classList.toggle('is-up', r === 'up');
    if (rateDown) rateDown.classList.toggle('is-down', r === 'down');
  }
  function sendRate(r) {
    if (!currentKey) return;
    setRating(r);
    fetch((CFG.url).replace(/\/$/, '') + '/rate', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key: currentKey, rating: r, title: currentProduct && currentProduct.title, age: currentAge })
    }).catch(function () {});
    // Only CURATION mode re-rolls (a paid regeneration). For shoppers, 👎 just
    // records the feedback — otherwise every dislike would cost a generation.
    if (r === 'down' && currentProduct && CFG.curation) { run(currentProduct, true); return; }
    if (r === 'down' && panelNote) panelNote.textContent = 'Thanks — your feedback helps us improve.';
  }
  function openPanel(product) {
    currentProduct = product || currentProduct;
    panel.hidden = false;
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    if (!currentProduct) return showBase('Drag a garment onto the child to try it on', ' ');
    run(currentProduct); // one-pieces -> FASHN, sets -> nano-banana (routed by the service)
  }
  function closePanel() { panel.classList.remove('is-open'); setTimeout(function () { panel.hidden = true; }, 260); }
  function tryOn(product) { openPanel(product); }

  function garmentPayload(product) {
    if (/^https?:/i.test(product.image)) return Promise.resolve(product.image); // service fetches it
    return fetch(product.image).then(function (r) { return r.blob(); }).then(function (b) {
      return new Promise(function (res) { var fr = new FileReader(); fr.onload = function () { res(fr.result); }; fr.readAsDataURL(b); });
    });
  }

  function run(product, regen) {
    currentProduct = product; currentKey = null;
    dock.classList.add('is-busy');
    panelTitle.textContent = product.title;
    panelNote.textContent = regen ? 'Re-rolling a fresh look…' : 'AI preview — actual fit and colour may vary.';
    setRating(null);
    if (rateRow) rateRow.style.visibility = 'hidden';
    panelImg.classList.remove('is-ready');
    panelLoading.classList.add('is-show');
    startBake();
    var seq = ++reqSeq;
    garmentPayload(product).then(function (garment) {
      return fetch((CFG.url).replace(/\/$/, '') + '/tryon', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ garment: garment, age: currentAge, type: product.type, title: product.title, gender: product.gender || '', regen: !!regen })
      });
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (seq !== reqSeq) return;
      dock.classList.remove('is-busy');
      if (j && j.url) {
        currentKey = j.key || null;
        finishBake();
        panelImg.onload = function () {
          panelLoading.classList.remove('is-show'); panelImg.classList.add('is-ready');
          panelNote.textContent = 'AI preview — actual fit and colour may vary.';
          if (rateRow) rateRow.style.visibility = currentKey ? 'visible' : 'hidden';
          setRating(j.rating || null);
        };
        panelImg.src = j.url;
      } else { stopBake(); panelLoading.classList.remove('is-show'); panelTitle.textContent = 'Could not style this one — try another'; }
    }).catch(function () {
      if (seq !== reqSeq) return;
      dock.classList.remove('is-busy'); stopBake(); panelLoading.classList.remove('is-show');
      panelTitle.textContent = 'Fitting room offline';
    });
  }

  window.RackTryOn = { init: init, isOver: isOver, hover: hover, clearHover: clearHover, tryOn: tryOn };
})();


/* ===== src/rack.js ===== */
/*
 * rack.js — the swipeable "shop the rack" engine (real M&P photo cutouts).
 *
 * Cover Flow layout + spring-physics hanger sway. Filterable by type/size.
 * Gestures on the focused garment:
 *   • tap            -> open the product lightbox
 *   • pull DOWN      -> add to bag (or, if released over the fitting-room model,
 *                       try it on — see window.RackTryOn)
 *
 * The bag is shared: window.RackBag.add() is called by BOTH the pull-down here
 * and the lightbox's Add to Cart, so the badge always reflects every add.
 *
 * Desktop-first: mouse drag, wheel, Left/Right arrows. No bundler / no server.
 */
(function () {
  'use strict';

  var Spring = window.RackPhysics.Spring;
  var clamp = window.RackPhysics.clamp;

  // ---- layout / feel tunables ------------------------------------------------
  // Scaled per breakpoint so the rack reads well from phone to desktop; the
  // shape of the coverflow (angle/steps) stays constant, only the pixel scale
  // of the "room" changes. Recomputed on resize via metrics().
  var BREAKPOINTS = [
    { max: 480,  scale: 0.52 },  // phone
    { max: 700,  scale: 0.68 },  // large phone / small tablet
    { max: 1024, scale: 0.85 },  // tablet
    { max: Infinity, scale: 1 }  // desktop
  ];
  var REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CFG = {};
  function metrics() {
    var w = window.innerWidth;
    var scale = BREAKPOINTS.filter(function (b) { return w <= b.max; })[0].scale;
    // fullscreen: the stage is far taller than the banner — size garments to the
    // room (52% of stage height) instead of leaving them banner-sized and tiny
    if (stageEl && stageEl.clientHeight > 620) {
      scale = Math.min(2.4, Math.max(scale, (stageEl.clientHeight * 0.52) / 300));
    }
    CFG.scale = scale;
    CFG.DISPLAY_H = Math.round(300 * scale);
    CFG.FOCUS_SPACING = Math.round(300 * scale);
    CFG.SIDE_SPACING = Math.round(80 * scale);
    CFG.ANGLE = 44; // tilt reads the same at any size
    CFG.DEPTH = Math.round(240 * scale);
    CFG.SCALE_STEP = 0.12;
    CFG.MIN_SCALE = 0.6;
    CFG.DIM_STEP = 0.16;
    CFG.WINDOW = 4;
    CFG.SWAY_GAIN = 5.5;
    CFG.SWAY_MAX = 15;
    CFG.AMBIENT_AMP = 0.8;
    CFG.FLICK = 0.12;
    CFG.PULL_MAX = Math.round(150 * scale);
    CFG.PULL_THRESHOLD = Math.round(88 * scale);
    if (REDUCED_MOTION) CFG.AMBIENT_AMP = 0; // no idle sway for motion-sensitive users
    return CFG;
  }
  metrics();

  var SIZE_ORDER = ['Newborn', 'Up to 1 Month', '0-1 Months', 'Tiny Baby', '0-3 Months',
    '2-3 Months', '3-6 Months', '6-9 Months', '9-12 Months', '12-18 Months',
    '18-24 Months', '2-3 Years', '3-4 Years'];

  // Shopify product types are inconsistently pluralised — merge the dupes.
  var TYPE_ALIAS = { 'Sleepsuits': 'Sleepsuit', 'Bodysuits': 'Bodysuit', 'Rompers': 'Romper', 'Dresses': 'Dress' };
  function normType(t) { return TYPE_ALIAS[t] || t || 'Other'; }

  var ICON_EXPAND = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/>' +
    '<path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/>' +
    '<path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>';
  var ICON_SHRINK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3v3a2 2 0 0 1-2 2H3"/>' +
    '<path d="M21 8h-3a2 2 0 0 1-2-2V3"/><path d="M3 16h3a2 2 0 0 1 2 2v3"/>' +
    '<path d="M16 21v-3a2 2 0 0 1 2-2h3"/></svg>';
  var ICON_PREV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  var ICON_NEXT = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';

  // ---- cart wiring ----------------------------------------------------------
  // The Shopify section emits window.SHOP_THE_RACK = { products:[...],
  //   cart:{ mode:'shopify', addUrl:'/cart/add.js' } }.  Standalone => mock.
  var BOOT = window.SHOP_THE_RACK || {};
  var CART = BOOT.cart || { mode: 'mock', addUrl: '/cart/add.js' };
  var shopifyMode = CART.mode === 'shopify';

  // price formatter (in the standalone prototype products.js also defines this;
  // in the Shopify bundle products come from Liquid, so define it here too).
  if (typeof window.formatPrice !== 'function') {
    window.formatPrice = function (cents, currency) {
      var symbol = currency === 'USD' ? '$' : currency === 'GBP' ? '£' : currency === 'EUR' ? '€' : '';
      return symbol ? symbol + (cents / 100).toFixed(2) : (cents / 100).toFixed(2) + ' ' + (currency || '');
    };
  }

  // ---- state ----------------------------------------------------------------
  var rackEl, stageEl, items = [], order = [];        // order = currently-visible items
  var filter = { type: 'All', size: 'All' };
  var scroll, snapTarget = 0, prevScroll = 0, rackVel = 0;
  var dragging = false, pointerId = null, axis = null;
  var dragStartX = 0, dragStartY = 0, dragStartScroll = 0, dragMoved = false, startedFocused = false;
  var pull = { active: false, amount: 0, dx: 0, pos: -1 }; // amount = carry Y, dx = carry X
  var bagCount = 0;
  var tryOn = null; // window.RackTryOn once the fitting room is enabled (BOOT.tryon)

  function hash(i) { var x = Math.sin(i * 12.9898) * 43758.5453; return x - Math.floor(x); }
  function M() { return order.length; }
  function focusedPos() { return clamp(Math.round(scroll.value), 0, Math.max(0, M() - 1)); }
  function focusedItem() { return order[focusedPos()]; }

  function build() {
    stageEl = document.getElementById('stage');
    rackEl = document.getElementById('rack');

    var products = BOOT.products || window.RACK_PRODUCTS || [];
    products.forEach(function (p, i) {
      var root = document.createElement('div');
      root.className = 'item'; root.dataset.index = i;
      var swing = document.createElement('div'); swing.className = 'swing';
      var img = document.createElement('img'); img.className = 'garment-img';
      img.src = p.image; img.alt = p.title; img.draggable = false;
      img.loading = 'lazy'; // don't load a whole catalog at once; only what's on-rail
      swing.appendChild(img);
      var tag = document.createElement('div'); tag.className = 'tag';
      tag.innerHTML = '<span class="tag-info"><span class="tag-title">' + p.title + '</span>' +
        '<span class="tag-price">' + window.formatPrice(p.priceCents, p.currency) + '</span></span>' +
        '<button type="button" class="tag-add" aria-label="Quick add to bag">+</button>';
      var tagAdd = tag.querySelector('.tag-add');
      // don't let the button start a stage drag / register as a garment tap
      tagAdd.addEventListener('pointerdown', function (ev) { ev.stopPropagation(); });
      tagAdd.addEventListener('click', function (ev) {
        ev.stopPropagation();
        if (items[i].pos >= 0) quickAdd(items[i].pos);
      });
      root.appendChild(swing); root.appendChild(tag); rackEl.appendChild(root);
      items.push({
        product: p, root: root, swing: swing, img: img, tag: tag, pos: i,
        swayFactor: 0.85 + hash(i) * 0.3,
        sway: new Spring({ stiffness: 86 + hash(i + 1) * 20, damping: 6.2 + hash(i + 2) * 1.6, mass: 1 })
      });
    });
    layoutItems();

    scroll = new Spring({ value: 0, target: 0, stiffness: 130, damping: 22, mass: 1 });
    buildChrome();
    buildFilters();
    applyFilter();
    // fitting room: enable the drag-a-garment-onto-the-kid try-on if configured
    tryOn = (BOOT.tryon && window.RackTryOn) ? window.RackTryOn : null;
    if (tryOn) tryOn.init(BOOT.tryon);
    // entrance: garments glide in along the rail and settle with a sway
    if (!REDUCED_MOTION && order.length) scroll.value = -2.2;
    bindInput();
    bindResize();
    loop(performance.now());
  }

  // (re)apply per-garment pixel sizing for the current breakpoint
  // Show the full branded hanger (logo visible), hook curling just over the rail. NOTE:
  // the AI re-hang varies the hook (silver wire vs tan knob) AND its vertical position,
  // so no crop value makes them uniform — true consistency needs the master-hanger
  // composite. This is the best "every item has a branded hanger" interim.
  var HOOK_CROP = 0.0;
  var HANG_LIFT = 0.0; // metal hook sits at height 0 on the rail (no float above)
  function layoutItems() {
    var h = CFG.DISPLAY_H;
    document.documentElement.style.setProperty('--display-h', h + 'px');
    document.documentElement.style.setProperty('--hook-crop', (HOOK_CROP * 100) + '%');
    items.forEach(function (it) {
      var w = Math.round(h * (it.product.imgW / it.product.imgH));
      it.root.style.width = w + 'px';
      it.root.style.marginLeft = (-w / 2) + 'px';
      it.img.style.height = h + 'px';
      it.img.style.marginTop = Math.round(-h * HANG_LIFT) + 'px';
    });
  }

  var resizeTimer = null;
  function bindResize() {
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { metrics(); layoutItems(); }, 120);
    });
  }

  // ---- chrome: bag badge, pull hint, size popover, empty state -------------
  var bagEl, sizePop, pullHint, emptyEl, fsBtn, prevBtn, nextBtn, counterEl, dockEl, filterChipsEl, sizeDD;
  function buildChrome() {
    // In Shopify mode we do NOT show a separate bag — the theme's own cart
    // drawer + header cart bubble are the cart. Only the prototype gets a bag.
    if (!shopifyMode) {
      bagEl = document.createElement('button');
      bagEl.className = 'bag';
      bagEl.innerHTML = 'Bag <span class="bag-count">0</span>';
      stageEl.appendChild(bagEl);
    }

    fsBtn = document.createElement('button');
    fsBtn.className = 'fs-btn';
    fsBtn.setAttribute('aria-label', 'View full screen');
    fsBtn.innerHTML = ICON_EXPAND;
    fsBtn.addEventListener('click', toggleFullscreen);
    stageEl.appendChild(fsBtn);
    document.addEventListener('fullscreenchange', onFullscreenChange);

    prevBtn = document.createElement('button');
    prevBtn.className = 'rack-arrow rack-arrow-prev';
    prevBtn.setAttribute('aria-label', 'Previous garment');
    prevBtn.innerHTML = ICON_PREV;
    prevBtn.addEventListener('click', function () { goTo(snapTarget - 1); });
    stageEl.appendChild(prevBtn);

    nextBtn = document.createElement('button');
    nextBtn.className = 'rack-arrow rack-arrow-next';
    nextBtn.setAttribute('aria-label', 'Next garment');
    nextBtn.innerHTML = ICON_NEXT;
    nextBtn.addEventListener('click', function () { goTo(snapTarget + 1); });
    stageEl.appendChild(nextBtn);

    counterEl = document.createElement('div');
    counterEl.className = 'rack-counter';
    counterEl.setAttribute('aria-hidden', 'true');
    stageEl.appendChild(counterEl);

    dockEl = document.createElement('div');
    dockEl.className = 'rack-dock';
    dockEl.setAttribute('aria-label', 'Jump to a garment');
    // filmstrip in normal flow right under the stage — can never overlap the tag
    stageEl.parentNode.insertBefore(dockEl, stageEl.nextSibling);

    pullHint = document.createElement('div');
    pullHint.className = 'pull-hint';
    pullHint.innerHTML = '<span class="ph-pull">Pull down to add to bag</span>' +
      '<span class="ph-release">Release to add to bag</span>' +
      '<span class="ph-tryon">Release to try it on</span>';
    stageEl.appendChild(pullHint);

    sizePop = document.createElement('div');
    sizePop.className = 'sizepop'; sizePop.hidden = true;
    stageEl.appendChild(sizePop);
    stageEl.addEventListener('pointerdown', function (e) {
      if (!sizePop.hidden && !sizePop.contains(e.target)) hideSizePicker();
    }, true);

    emptyEl = document.createElement('div');
    emptyEl.className = 'rack-empty'; emptyEl.hidden = true;
    emptyEl.innerHTML = '<p class="rack-empty-msg">Nothing on the rail matches those filters.</p>' +
      '<button type="button" class="rack-empty-btn">Clear filters</button>';
    emptyEl.querySelector('.rack-empty-btn').addEventListener('click', resetFilters);
    stageEl.appendChild(emptyEl);
  }

  function bumpBag(n) {
    if (!bagEl) return;
    bagCount += (n || 1);
    bagEl.querySelector('.bag-count').textContent = bagCount;
    bagEl.classList.remove('pop'); void bagEl.offsetWidth; bagEl.classList.add('pop');
  }

  function toggleFullscreen() {
    if (!document.fullscreenElement) {
      (stageEl.requestFullscreen ? stageEl.requestFullscreen() : Promise.reject()).catch(function () {});
    } else {
      document.exitFullscreen().catch(function () {});
    }
  }
  function onFullscreenChange() {
    var on = document.fullscreenElement === stageEl;
    stageEl.classList.toggle('is-fullscreen', on);
    fsBtn.innerHTML = on ? ICON_SHRINK : ICON_EXPAND;
    fsBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'View full screen');
    metrics(); layoutItems(); // garment scale tracks the stage height
  }

  // ---- filter bar -----------------------------------------------------------
  function buildFilters() {
    var products = BOOT.products || window.RACK_PRODUCTS || [];
    // types in descending frequency
    var counts = {}; products.forEach(function (p) { var t = normType(p.type); counts[t] = (counts[t] || 0) + 1; });
    var types = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    // sizes present, canonical order
    var sset = {}; products.forEach(function (p) {
      p.options.forEach(function (o) { if (/size/i.test(o.name)) o.values.forEach(function (v) { sset[v] = 1; }); });
    });
    var sizes = Object.keys(sset).sort(function (a, b) {
      var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });

    var bar = document.createElement('div'); bar.className = 'filters';
    var chips = document.createElement('div'); chips.className = 'filter-types';
    ['All'].concat(types).forEach(function (t) {
      var b = document.createElement('button');
      b.className = 'filter-chip' + (t === 'All' ? ' is-active' : '');
      b.dataset.type = t;
      var n = t === 'All' ? products.length : counts[t];
      b.innerHTML = t + ' <span class="chip-count">' + n + '</span>';
      b.addEventListener('click', function () {
        filter.type = t;
        chips.querySelectorAll('.filter-chip').forEach(function (c) { c.classList.toggle('is-active', c === b); });
        applyFilter();
      });
      chips.appendChild(b);
    });

    var sizeWrap = document.createElement('div'); sizeWrap.className = 'filter-size';
    sizeWrap.innerHTML = '<span class="filter-size-label">Size</span>';
    sizeWrap.appendChild(buildSizeDropdown(sizes));

    bar.appendChild(chips); bar.appendChild(sizeWrap);
    stageEl.parentNode.insertBefore(bar, stageEl); // toolbar sits ABOVE the stage, not overlaid
    filterChipsEl = chips;
  }

  // custom dropdown — the native <select> popup can't be styled to match the design.
  // The menu is position:fixed and appended to the section root so the toolbar's
  // overflow (horizontal scroll on mobile) can never clip it.
  function buildSizeDropdown(sizes) {
    var dd = document.createElement('div'); dd.className = 'size-dd';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'size-dd-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.innerHTML = '<span class="size-dd-label">All sizes</span>' +
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    var labelEl = btn.querySelector('.size-dd-label');
    var menu = document.createElement('div'); menu.className = 'size-dd-menu';

    ['All'].concat(sizes).forEach(function (s) {
      var o = document.createElement('button');
      o.type = 'button';
      o.className = 'size-dd-opt' + (s === 'All' ? ' is-active' : '');
      o.dataset.value = s;
      o.textContent = s === 'All' ? 'All sizes' : s;
      o.addEventListener('click', function () { setSize(s); close(); });
      menu.appendChild(o);
    });

    function setSize(val) {
      filter.size = val;
      labelEl.textContent = val === 'All' ? 'All sizes' : val;
      menu.querySelectorAll('.size-dd-opt').forEach(function (o) {
        o.classList.toggle('is-active', o.dataset.value === val);
      });
      applyFilter();
    }
    function open() {
      dd.classList.add('is-open'); menu.classList.add('is-open');
      var r = btn.getBoundingClientRect(), mw = menu.offsetWidth;
      menu.style.left = Math.max(10, Math.min(r.left, window.innerWidth - mw - 10)) + 'px';
      menu.style.top = (r.bottom + 8) + 'px';
    }
    function close() { dd.classList.remove('is-open'); menu.classList.remove('is-open'); }
    btn.addEventListener('click', function () {
      if (menu.classList.contains('is-open')) close(); else open();
    });
    document.addEventListener('pointerdown', function (e) {
      if (!menu.contains(e.target) && !btn.contains(e.target)) close();
    });
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);

    dd.appendChild(btn);
    (stageEl.closest('.shop-the-rack') || document.body).appendChild(menu);
    sizeDD = { set: setSize };
    return dd;
  }

  function resetFilters() {
    filter.type = 'All';
    if (filterChipsEl) filterChipsEl.querySelectorAll('.filter-chip').forEach(function (c) {
      c.classList.toggle('is-active', c.dataset.type === 'All');
    });
    if (sizeDD) { sizeDD.set('All'); } // set() re-applies the filter
    else { filter.size = 'All'; applyFilter(); }
  }

  function productHasSize(p, size) {
    return p.variants.some(function (v) { return v.options.indexOf(size) >= 0 && v.available; });
  }

  function applyFilter() {
    order = items.filter(function (it) {
      var p = it.product;
      if (filter.type !== 'All' && normType(p.type) !== filter.type) return false;
      if (filter.size !== 'All' && !productHasSize(p, filter.size)) return false;
      return true;
    });
    items.forEach(function (it) { it.pos = -1; });
    order.forEach(function (it, k) { it.pos = k; });
    hideSizePicker();
    pull.active = false; pull.amount = 0; pull.dx = 0; pull.pos = -1;
    snapTarget = 0;
    scroll.value = 0; scroll.target = 0; scroll.velocity = 0;
    emptyEl.hidden = order.length > 0;
    buildDock();
    updateNav();
  }

  // the "wardrobe drawer": one thumbnail per visible garment, click to jump
  function buildDock() {
    if (!dockEl) return;
    dockEl.innerHTML = '';
    order.forEach(function (it, k) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dock-thumb';
      b.setAttribute('aria-label', it.product.title);
      b.title = it.product.title;
      var im = document.createElement('img');
      im.src = it.product.image; im.alt = ''; im.loading = 'lazy'; im.draggable = false;
      b.appendChild(im);
      b.addEventListener('click', function () { goTo(k); });
      dockEl.appendChild(b);
    });
    dockEl.hidden = order.length < 2;
  }

  // keep the prev/next arrows, "n / m" counter and dock in sync with the focused item
  function updateNav() {
    if (!counterEl) return;
    var m = M(), pos = focusedPos(), has = m > 0;
    counterEl.hidden = !has; prevBtn.hidden = !has; nextBtn.hidden = !has;
    if (!has) return;
    counterEl.textContent = (pos + 1) + ' / ' + m;
    prevBtn.disabled = pos <= 0;
    nextBtn.disabled = pos >= m - 1;
    if (dockEl && !dockEl.hidden) {
      var thumbs = dockEl.children, act = thumbs[pos];
      for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.toggle('is-active', i === pos);
      if (act) dockEl.scrollTo({
        left: act.offsetLeft - dockEl.clientWidth / 2 + act.offsetWidth / 2,
        behavior: 'smooth'
      });
    }
  }

  // ---- input ----------------------------------------------------------------
  function bindInput() {
    stageEl.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp); // e.g. dock pan-x steals the pointer
    stageEl.addEventListener('wheel', function (e) {
      e.preventDefault();
      goTo(snapTarget + ((Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY) > 0 ? 1 : -1));
    }, { passive: false });
    window.addEventListener('keydown', function (e) {
      if (!document.getElementById('lightbox').hasAttribute('hidden')) return;
      if (!sizePop.hidden) return;
      if (e.key === 'ArrowLeft') { goTo(snapTarget - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { goTo(snapTarget + 1); e.preventDefault(); }
      else if (e.key === 'Enter' || e.key === ' ') { openFocused(); e.preventDefault(); }
    });
  }

  function itemFromEvent(e) {
    var el = e.target.closest && e.target.closest('.item');
    if (!el) return null;
    var it = items[parseInt(el.dataset.index, 10)];
    return (it && it.pos >= 0) ? it : null;
  }

  function onDown(e) {
    if (!sizePop.hidden) return;
    dragging = true; dragMoved = false; axis = null; pointerId = e.pointerId;
    dragStartX = e.clientX; dragStartY = e.clientY; dragStartScroll = scroll.value; scroll.velocity = 0;
    var it = itemFromEvent(e);
    startedFocused = !!(it && it.pos === focusedPos());
    stageEl.classList.add('is-grabbing');
  }

  function onMove(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    var dx = e.clientX - dragStartX, dy = e.clientY - dragStartY;
    if (!axis) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      dragMoved = true;
      stageEl.classList.add('has-interacted'); // fades out the gesture hint
      // when the fitting room is on, a downward drag is looser to detect so you
      // can lift a garment and carry it toward the model in the corner
      axis = (dy > 0 && Math.abs(dy) > Math.abs(dx) * (tryOn ? 0.5 : 1.2) && startedFocused) ? 'pull' : 'x';
      if (axis === 'pull') { pull.active = true; pull.pos = focusedPos(); if (tryOn) stageEl.classList.add('is-carrying'); }
    }
    if (axis === 'x') {
      scroll.value = clamp(dragStartScroll - dx / CFG.FOCUS_SPACING, -0.55, M() - 0.45);
    } else if (tryOn) {
      // fitting room on -> the garment is picked up and follows the cursor in 2D
      // (full range) so you can carry it all the way onto the model
      pull.dx = dx;
      pull.amount = Math.max(0, dy);
      var overDock = tryOn.isOver(e.clientX, e.clientY);
      tryOn.hover(e.clientX, e.clientY);
      pullHint.classList.toggle('is-tryon', !!overDock);
      pullHint.classList.toggle('is-armed', !!overDock || pull.amount > CFG.PULL_THRESHOLD);
      pullHint.classList.add('is-show');
    } else {
      // no fitting room -> the original springy "pull down to add" (vertical only)
      pull.dx = 0;
      var t = clamp(dy, 0, CFG.PULL_MAX + 40);
      pull.amount = t <= CFG.PULL_MAX ? t : CFG.PULL_MAX + (t - CFG.PULL_MAX) * 0.3;
      pullHint.classList.toggle('is-armed', pull.amount > CFG.PULL_THRESHOLD);
      pullHint.classList.add('is-show');
    }
  }

  function onUp(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    dragging = false; pointerId = null;
    stageEl.classList.remove('is-grabbing', 'is-carrying');
    pullHint.classList.remove('is-show', 'is-armed', 'is-tryon');
    if (axis === 'pull') {
      pull.active = false;
      var overDock = tryOn && tryOn.isOver(e.clientX, e.clientY);
      if (tryOn) tryOn.clearHover();
      if (overDock) { var pit = order[pull.pos]; if (pit) tryOn.tryOn(pit.product); } // drop on the kid -> try on
      else if (pull.amount > CFG.PULL_THRESHOLD) quickAdd(pull.pos);                   // pulled far enough -> add to bag
      return;
    }
    if (!dragMoved) {
      var it = itemFromEvent(e);
      if (it) { if (it.pos === focusedPos()) openFocused(); else goTo(it.pos); }
      return;
    }
    snapTarget = clamp(Math.round(scroll.value + rackVel * CFG.FLICK), 0, M() - 1);
    scroll.target = snapTarget;
  }

  function goTo(pos) {
    if (!M()) return;
    stageEl.classList.add('has-interacted'); // fades out the gesture hint
    snapTarget = clamp(pos, 0, M() - 1); scroll.target = snapTarget;
  }
  function openFocused() { var it = focusedItem(); if (it) window.RackLightbox.open(it.product); }

  // ---- pull-down-to-add ----------------------------------------------------
  function quickAdd(pos) {
    var it = order[pos]; if (!it) return;
    var avail = it.product.variants.filter(function (v) { return v.available; });
    if (!avail.length) { window.RackBag.toast('Sorry — ' + it.product.title + ' is sold out'); return; }
    if (avail.length === 1) return addVariant(it, avail[0]);
    showSizePicker(it, avail);
  }

  function showSizePicker(it, avail) {
    sizePop.innerHTML = '<div class="sizepop-title">Choose a size</div>' +
      '<div class="sizepop-product">' + it.product.title + '</div><div class="sizepop-chips"></div>';
    var chips = sizePop.querySelector('.sizepop-chips');
    avail.forEach(function (v) {
      var b = document.createElement('button'); b.className = 'sizepop-chip';
      b.textContent = v.options[0] || v.title;
      b.addEventListener('click', function () { hideSizePicker(); addVariant(it, v); });
      chips.appendChild(b);
    });
    sizePop.hidden = false;
    var r = it.root.getBoundingClientRect(), s = stageEl.getBoundingClientRect();
    var pr = sizePop.getBoundingClientRect(), popW = pr.width, popH = pr.height;
    var pad = 10;
    var idealLeft = (r.left - s.left + r.width / 2) - popW / 2;
    var left = clamp(idealLeft, pad, Math.max(pad, s.width - popW - pad));
    // keep the popover fully inside the stage (it gets clipped by overflow:hidden otherwise)
    var idealTop = r.top - s.top + Math.min(r.height, CFG.DISPLAY_H) + 24;
    var top = Math.min(idealTop, s.height - popH - pad);
    if (top < pad) top = pad;
    sizePop.style.left = left + 'px';
    sizePop.style.top = top + 'px';
    // the little pointer stays aimed at the garment even if the box had to shift;
    // hide it when the popover had to move up off its anchor point
    sizePop.style.setProperty('--arrow-x', (idealLeft + popW / 2 - left) + 'px');
    sizePop.classList.toggle('is-clamped', top < idealTop - 4);
  }
  function hideSizePicker() { if (sizePop) sizePop.hidden = true; }

  function addVariant(it, variant) {
    window.RackBag.add({ product: it.product, variant: variant, qty: 1,
      label: variant.options[0] || variant.title, fromEl: it.img });
  }

  function flyTarget() {
    // prototype -> our bag badge; Shopify -> the theme's header cart icon
    return shopifyMode ? document.querySelector('#cart-icon-bubble') : bagEl;
  }
  function flyToBag(imgEl) {
    var target = flyTarget();
    if (!target) return;
    var r = imgEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var ghost = imgEl.cloneNode(true); ghost.className = 'fly-ghost';
    ghost.style.left = r.left + 'px'; ghost.style.top = r.top + 'px';
    ghost.style.width = r.width + 'px'; ghost.style.height = r.height + 'px';
    // append inside the section root so scoped (Shopify) CSS still styles it
    (stageEl.closest('.shop-the-rack') || document.body).appendChild(ghost);
    requestAnimationFrame(function () {
      ghost.style.transform = 'translate(' + (b.left + b.width / 2 - r.left - r.width / 2) + 'px,' +
        (b.top + b.height / 2 - r.top - r.height / 2) + 'px) scale(0.12) rotate(8deg)';
      ghost.style.opacity = '0.15';
    });
    setTimeout(function () { ghost.remove(); }, 620);
  }

  // ---- shared bag / cart (used by rack + lightbox) --------------------------
  var toastEl, toastTimer = null;
  function toast(msg) {
    if (!toastEl) toastEl = document.getElementById('toast');
    toastEl.textContent = msg; toastEl.removeAttribute('hidden'); toastEl.classList.add('is-show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-show'); setTimeout(function () { toastEl.setAttribute('hidden', ''); }, 300);
    }, 2600);
  }
  // POST to Shopify's real AJAX cart, then re-render + open the theme cart drawer
  function shopifyAdd(opts) {
    var qty = opts.qty || 1;
    var fd = new FormData();
    fd.append('id', opts.variant.id);
    fd.append('quantity', qty);
    fd.append('sections', 'cart-drawer,cart-icon-bubble'); // theme drawer + header count
    fd.append('sections_url', window.location.pathname);
    fetch(CART.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) { toast(res.description || res.message || 'Could not add to bag'); return; }
      if (opts.fromEl) flyToBag(opts.fromEl); // garment flies to the header cart
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
      // (the theme drawer opening + header bubble updating IS the confirmation)
    }).catch(function () { toast('Could not add to bag'); });
  }

  window.RackBag = {
    add: function (opts) {
      if (shopifyMode) return shopifyAdd(opts);          // real Shopify cart
      // prototype: log the exact payload the theme will POST, update our bag
      console.log('[cart/add.js] POST', JSON.stringify({ items: [{ id: opts.variant.id, quantity: opts.qty || 1 }] }));
      this.notify(opts);
    },
    // UI only: bump our bag badge, fly-to-bag, toast (prototype mode)
    notify: function (opts) {
      var qty = opts.qty || 1;
      bumpBag(qty);
      if (opts.fromEl) flyToBag(opts.fromEl);
      toast('Added to bag — ' + opts.product.title + (opts.label ? ' · ' + opts.label : '') + (qty > 1 ? ' ×' + qty : ''));
    },
    toast: toast
  };

  // ---- simulation -----------------------------------------------------------
  function update(dt) {
    if (!dragging) scroll.step(dt);
    rackVel = (scroll.value - prevScroll) / dt; prevScroll = scroll.value;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      it.sway.setTarget(clamp(rackVel * CFG.SWAY_GAIN * it.swayFactor, -CFG.SWAY_MAX, CFG.SWAY_MAX));
      it.sway.step(dt);
    }
    // spring the carried garment back to the rail on release
    if (!pull.active && (pull.amount > 0.1 || Math.abs(pull.dx) > 0.1)) { pull.amount *= 0.78; pull.dx *= 0.78; }
    else if (!pull.active) { pull.amount = 0; pull.dx = 0; }
  }

  var lastNavPos = -1, lastNavLen = -1;
  function render(t) {
    var s = scroll.value;
    var fp = focusedPos();
    if (fp !== lastNavPos || M() !== lastNavLen) { lastNavPos = fp; lastNavLen = M(); updateNav(); }
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.pos < 0) { it.root.style.display = 'none'; it.root.classList.remove('is-focus'); continue; }
      var rel = it.pos - s, arel = Math.abs(rel);
      if (arel > CFG.WINDOW + 0.6) { it.root.style.display = 'none'; it.root.classList.remove('is-focus'); continue; }
      it.root.style.display = '';

      var srel = rel < 0 ? -1 : 1;
      var x = arel <= 1 ? rel * CFG.FOCUS_SPACING : srel * (CFG.FOCUS_SPACING + (arel - 1) * CFG.SIDE_SPACING);
      var ry = -clamp(rel, -1, 1) * CFG.ANGLE;
      var tz = -Math.min(arel, 1) * CFG.DEPTH - Math.max(arel - 1, 0) * 26;
      var sc = Math.max(CFG.MIN_SCALE, 1 - arel * CFG.SCALE_STEP);
      var op = Math.max(0.3, 1 - arel * CFG.DIM_STEP);

      it.root.style.transform =
        'translateX(' + x.toFixed(1) + 'px) translateZ(' + tz.toFixed(1) + 'px) ' +
        'rotateY(' + ry.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
      it.root.style.opacity = op.toFixed(3);
      it.root.style.zIndex = String(Math.round(1000 - arel * 10));

      var ambient = CFG.AMBIENT_AMP * Math.sin(t * 1.1 + i * 1.7);
      var carried = (pull.pos === it.pos && arel < 0.5);
      var pullY = carried ? pull.amount : 0;
      var pullX = carried ? pull.dx : 0;
      it.swing.style.transform = 'translate(' + pullX.toFixed(1) + 'px,' + pullY.toFixed(1) + 'px) rotate(' + (it.sway.value + ambient).toFixed(2) + 'deg)';
      it.root.classList.toggle('is-carry', carried && (Math.abs(pullX) > 4 || pullY > 4));
      it.tag.style.opacity = clamp(1.15 - arel * 1.8, 0, 1).toFixed(2);
      it.root.classList.toggle('is-focus', arel < 0.5);
    }
  }

  var last = 0, acc = 0, STEP = 1 / 120;
  function loop(now) {
    if (!last) last = now;
    var dt = Math.min((now - last) / 1000, 0.05); last = now;
    acc += dt; var guard = 0;
    while (acc >= STEP && guard++ < 8) { update(STEP); acc -= STEP; }
    render(now / 1000);
    requestAnimationFrame(loop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();

